'use client';

import {cn} from '@/lib/utils';
import clsx from 'clsx';
import moment from 'moment';
import {useEffect, useRef, useState} from 'react';

type PopupProps = {
  popups: any;
};
export default function PopupModal({popups}: PopupProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [popup, setPopup] = useState<any>(null);
  const showId = (id: string) => 'popup-last-shown-' + id;
  const modalRef = useRef(null as HTMLDivElement | null);

  useEffect(() => {
    if (!popups || !Array.isArray(popups)) {
      return;
    }

    const filtered = popups
      .filter((item: any) => {
        if (item.start_at && moment(item.start_at).isAfter(moment())) {
          return false;
        }
        if (item.end_at && moment(item.end_at).isBefore(moment())) {
          return false;
        }
        if (item.options && item.options.interval) {
          if (typeof window !== 'undefined' && window.localStorage) {
            const lastShowStr = window.localStorage.getItem(showId(item.id));
            if (lastShowStr) {
              const lastShowAt = moment(lastShowStr);
              switch (item.options.interval) {
                case 'daily':
                  if (lastShowAt.isAfter(moment().startOf('day'))) {
                    return false;
                  }
                  break;
                case 'weekly':
                  if (lastShowAt.isAfter(moment().startOf('week'))) {
                    return false;
                  }
                  break;
                default:
                  if (
                    !isNaN(item.options.interval) &&
                    lastShowAt.isAfter(
                      moment().subtract(item.options.interval, 'minute') // by minute
                    )
                  ) {
                    return false;
                  }
                  break;
              }
            }
          }
        }
        return item.is_active && item.image?.url;
      })
      .sort((a: any, b: any) => (a.updatedAt < b.updatedAt ? 1 : -1)); // latest updated first

    const activePopup = filtered?.[0];
    if (activePopup) {
      setPopup(activePopup);
      setIsOpen(true);

      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(
          showId(activePopup.id),
          moment().format('YYYY-MM-DD HH:mm:ss')
        );
      }
    }
  }, [popups]);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        if (modalRef.current) {
          modalRef.current.focus();
        }
      }, 100);
    } else {
      (document?.querySelector('header') as any)?.focus();
      (document?.activeElement as any)?.blur();
    }
  }, [isOpen]);

  return (
    isOpen &&
    popup?.image?.url && (
      <div className="fixed w-full h-screen z-[999] top-0 flex flex-col items-center justify-center">
        <div className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50"></div>
        <div
          className={cn(
            'max-w-[calc(100%-2rem)] md:max-w-[60vw]',
            ' data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full  translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg  p-6  duration-200 outline-none '
          )}
        >
          <div className="flex flex-col gap-2 text-center sm:text-left">
            <h2 className="text-lg leading-none font-semibold"></h2>
          </div>
          <div className="min-h-[50vh] ">
            <div className="flex flex-col items-center justify-center gap-2">
              <div className="relative ">
                <a href={popup.url} className="block">
                  <img
                    style={popup?.options?.mobile_image_style ?? {}}
                    alt={popup.title}
                    className="object-contain md:hidden  rounded-sm max-h-[75vh] "
                    src={popup.mobile_image?.url ?? popup.image?.url}
                  />
                  <img
                    style={popup?.options?.image_style ?? {}}
                    alt={popup.title}
                    className="object-contain hidden md:flex rounded-sm max-h-[90vh] "
                    src={popup.image?.url}
                  />
                </a>
                <div
                  className={clsx(
                    'text-center md:mt-0 absolute right-[10px] top-[10px] outline-none '
                  )}
                  ref={modalRef}
                  tabIndex={-1}
                >
                  <button
                    className={clsx(
                      'border border-transparent inline-flex items-center justify-center gap-2 ',
                      'whitespace-nowrap transition-all bg-black/40 md:bg-black/60 rounded-full p-1'
                    )}
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsOpen(false);
                    }}
                  >
                    <span className="material-symbols-outlined text-white/60 hover:scale-110 text-[16px] md:text-[12px]">
                      close
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}
